import FilterModal, { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";

export const fields: FilterFieldConfig[] = [
    { key: "id", label: "Service ID", type: "text", default: "" },
    { key: "code", label: "Code", type: "text", default: "" },
    { key: "name", label: "Name", type: "text", default: "" },
    { key: "category", label: "Category", type: "text", default: "" },
    { key: "price", label: "Price", type: "text", default: "" },
    { key: "costType", label: "Cost Type", type: "text", default: "" },
    { key: "notes", label: "Notes", type: "text", default: "" },
    {
        key: "void",
        label: "Validity",
        type: "select",
        default: "no",
        options: [
            { value: "no", label: "Valid" },
            { value: "yes", label: "Void" },
            { value: "all", label: "All" },
        ],
    },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
    {
        key: "creatorId",
        label: "Created By",
        type: "asyncSelect",
        default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false,
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    {
        key: "updaterId",
        label: "Updated By",
        type: "asyncSelect",
        default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search User",
        isMulti: false,
    },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
];

export default function ServiceFilterForm() {
    return <FilterModal title = "Filter" width = {650} fields = {fields} />;
}
